export const softSkills = [
    { id: 1, name: "Adaptabilidad y flexibilidad" },
    { id: 2, name: "Atención al detalle" },
    { id: 3, name: "Capacidad de análisis" },
    { id: 4, name: "Comunicación clara" },
    { id: 5, name: "Creatividad e innovación" },
    { id: 6, name: "Empatía" },
    { id: 7, name: "Inteligencia emocional" },
    { id: 8, name: "Liderazgo" },
    { id: 9, name: "Motivación" },
    { id: 10, name: "Organización y estructura" },
    { id: 11, name: "Orientación a la acción" },
    { id: 12, name: "Orientación al cliente" },
    { id: 13, name: "Orientación a seguir instrucciones" },
    { id: 14, name: "Resolución de problemas" },
    { id: 15, name: "Resiliencia" },
    { id: 16, name: "Tolerancia a la frustración" },
    { id: 17, name: "Trabajo en equipo" }
];